<template>
  <div>
    <Main
      :orderCode="orderCode"
      :materialCode="materialCode"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @openEditFormDialog="openEditFormDialog"
      @reload="getData"
    />
    <el-dialog
      v-if="dialogOptionParams.visible"
      show-close
      visible
      width="600px"
      top="10vh"
      :title="dialogOptionParams.title"
      :close-on-click-modal="false"
      :before-close="() => (dialogOptionParams.visible = false)"
    >
      <edit-form
        ref="editForm"
        :code="dialogOptionParams.code"
        :orderCode="orderCode"
        :materialCode="materialCode"
        :disabled="disabled"
        @close="closeDialog"
        @reload="getData"
      />

      <span slot="footer">
        <el-button size="small" @click="cancel">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!dialogOptionParams.disabled"
          @click="save"
          >{{ $l("INDEX.btn_save") || "保存" }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import BaseTable from "@/mixins/base-table"
import EditForm from "./edit-from"
import Main from "./main.vue"
export default {
  props: {
    orderCode: String,
    materialCode: String,
    disabled: Boolean,
  },
  mixins: { BaseTable },
  components: { Main, EditForm },
  data() {
    return {
      loading: false,
      tableData: [],
      dialogOptionParams: {
        visible: false,
        title: "",
        code: "",
        disabled: false,
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode && !this.materialCode) return
      this.loading = true
      this.$api
        .orderGoodsPackageOrderByListApi({
          orderCode: this.orderCode,
          materialCode: this.materialCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    save() {
      this.$refs.editForm.save()
    },
    cancel() {
      this.$refs.editForm.cancel()
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        add:
          this.$l("tips_view_add_packaging_pro_usage_info") ||
          "添加订单产品包装用量信息",
        edit:
          this.$l("tips_view_modify_packaging_pro_usage_info") ||
          "修改订单产品包装用量信息",
        detail:
          this.$l("tips_view_check_packaging_pro_usage_info") ||
          "查看订单产品包装用量信息",
      }
      this.dialogOptionParams = {
        visible: true,
        title: types[type],
        code: params.code,
        disabled: type === "detail",
      }
    },
    closeDialog() {
      this.dialogOptionParams.visible = false
    },
  },
}
</script>
